import React, { PropsWithChildren } from 'react';
import { EntityWarningPanel } from "./EntityWarningPanel";
import { Grid } from '@material-ui/core';

export const EntityContentWrapper = ({ children }: PropsWithChildren<{}>) => {
  return (<Grid container spacing={2} alignItems="stretch">
    <EntityWarningPanel />
    {children}
  </Grid>);
}
